import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {SeguroCobertura} from '../_models/seguro-cobertura';
import {SegurosBienes} from '../_models/seguros-bienes';

@Injectable({
  providedIn: 'root'
})
export class SegurosbienesService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/segurosBienes/';
  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  listadoPorIdTipoConstruccion( idSeguro: string) {
    return this.httpClient.get( `${this.rutServicio}idSeguro/${idSeguro}/tipoConstruccion` ).pipe( map( res => res as SegurosBienes[] ) );
  }

  listadoPorIdTipoConstruccionEnabled( idSeguro: string ) {
    return this.httpClient.get( `${this.rutServicio}idSeguro/${idSeguro}/enabled/tipoConstruccion` ).pipe( map( res => res as SegurosBienes[] ) );
  }
  listadoPorIdSeguro( id: string ) {
    return this.httpClient.get( `${this.rutServicio}idSeguro/${id}` ).pipe( map( res => res as SegurosBienes[] ) );
  }

  listadoPorIdSeguroEnabled( id: string ) {
    return this.httpClient.get( `${this.rutServicio}idSeguro/${id}/enabled` ).pipe( map( res => res as SegurosBienes[] ) );
  }

  listadoEnabled() {
    return this.httpClient.get( `${this.rutServicio}enabled` ).pipe( map( res => res as SegurosBienes[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( `${this.rutServicio}${id}` ).pipe( map( res => res as SegurosBienes ) );
  }

  crear( regCrear: SegurosBienes ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegurosBienes ) );
  }

  actualizar( regActualizar: SegurosBienes ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: any[] ) {
    regActualizar.map( ( s: SegurosBienes ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as SegurosBienes[] ) );
  }
}
